'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ROOT = exports.ROOT = 'mdc-temporary-drawer';

var cssClasses = exports.cssClasses = {
  ROOT: ROOT,
  DRAWER_SELECTOR: ROOT + '__drawer',
  HEADER: ROOT + '__header',
  RIGHT: ROOT + '--right'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Drawer/constants.js
// module id = 113
// module chunks = 0